module.exports = __webpack_public_path__ + "img/ewm.526e1e93.png";